<span [class]="'indicator indicator--' + color"></span>
<ng-content></ng-content>
